import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';
import { styled } from 'linaria/react';

interface ContentProps {
  percentage?: string;
}
export const StyledContent = styled.div<ContentProps>`
  position: relative;
  height: 0;
  padding-top: ${(props) => props.percentage ?? 0};
  overflow: hidden;
`;

const inner = {
  default: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;

    * {
      //1 extra pixel to prevent possible background bleed
      width: calc(100% + 1px);
      height: calc(100% + 1px);
    }
  `,
  background: css`
    background-color: ${cssTheme.palette.grey09};
  `,
};

// 16:9 area, full height, crop sides if needed
const fit = {
  height: css`
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    width: auto;
  `,
  width: css`
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: auto;
  `,
};

interface Props {
  hasIllustration: boolean;
}

export const getClassnames = ({ hasIllustration }: Props) => {
  return {
    inner: inner.default,
    innerWithBackground: cx(inner.default, !hasIllustration && inner.background),
    image: cx(fit.height, hasIllustration && fit.width),
  };
};
